// import { api } from '@/utils/api'
// import alert from '../helpers/alert'
// import router from '../router'

const state = () => {
  return {
    tableTab: {
      label: null,
      value: null,
      url:
        process.env.VUE_APP_API_URL +
        '/admin/documentPath/getSpecialPathCompanyAll',
      currentUrl: null,
      page: 1
    },
    search: {
      field: 'special_path.name',
      type: 'like',
      value: '',
      companySelected: null,
      yearSelected: null
    }
  }
}

const getters = {}

const mutations = {
  updateTableTab(state, tab) {
    state.tableTab.currentUrl = tab.currentUrl
    state.tableTab.page = tab.page
  },
  updateCompany(state, data) {
    state.search.companySelected = data.companySelected
    state.search.yearSelected = data.yearSelected
  },
  updateSearch(state, data) {
    state.search.field = data.field
    state.search.value = data.value
  }
}

const actions = {}

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
}
